/**
 * @deprecated Top-layer surfaces do not fire portal events. To know when a top-layer surface opens
 * or closes, listen for the native `toggle` and `close` events.
 */
export const PORTAL_MOUNT_EVENT = 'akPortalMount';
/**
 * @deprecated Top-layer surfaces do not fire portal events. To know when a top-layer surface opens
 * or closes, listen for the native `toggle` and `close` events.
 */
export const PORTAL_UNMOUNT_EVENT = 'akPortalUnmount';
